import RandExp from 'randexp';

export const toISOLocal = (d: Date): string => {
  const z = (n: number) => `0${n}`.slice(-2);
  const zz = (n: number) => `00${n}`.slice(-3);
  let off = d.getTimezoneOffset();
  const sign = off < 0 ? '+' : '-';
  off = Math.abs(off);

  return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}T${z(
    d.getHours(),
  )}:${z(d.getMinutes())}${sign}${z(off / 60 || 0)}:${z(off % 60)}`;
};

export const generateId = (): string => {
  const regex = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;

  return new RandExp(regex).gen();
};

export const TipoIntervencaoList = [
  'Infraestrutura Cicloviária',
  'Infraestrutura para Pedestre',
  'Infraestrutura para Ônibus',
  'Semáforo',
  'Interdição na Pista',
  'Gestão de Velocidade',
  'Renovação de Sinalização',
  'Outro',
];

export const EspecificacaoList = [
  'Ciclovia',
  'Ciclofaixa Unidirecional',
  'Ciclofaixa Unidirecional com Segregador',
  'Ciclofaixa Bidirecional ',
  'Ciclofaixa Bidirecional com Segregador',
  'Ciclorrota',
  'Travessia Elevada',
  'Faixa Diagonal',
  'Ilha de Refúgio',
  'Calçada Verde',
  'Extensão do Meio-fio',
  'Interseção Elevada',
  'Faixa de Pedestre',
  'Faixa Exclusiva de Ônibus',
  'Sinalização de Parada de Ônibus',
  'BRT',
  'BRS',
  'Convencional',
  'Centralizado',
  'Pedestre',
  'Ciclista',
  'Semáforo',
  'Recape',
  'Desvio e Obra',
  'Tapa-Buraco',

  'Lombada Física',
  'Fiscalização Eletrônica',
  'Chicanas',
  'Área de Trânsito Calmo',
  'Redutor de Velocidade',
  'Readequação do Limite de Velocidade',
  'Horizontal',
  'Vertical',
  'Horizontal e Vertical',
  'Projeto Escola',
  'Zona Azul',
  'Esquina Segura Convencional',
  'Esquina Segura 2.0',
  'Videomonitoramento',
  'Sinalização Turística',
  'X de Garagem',
  'Márcação de Área de Conflito',
  'Ponto de Táxi/Mototáxi',
  'Regulamentação de Estacionamento',
  'Vaga Especial',
  'Marcação de Carga/Descarga',
  'Abertura/Fechamento Canteiro',
  'Reconstrução de Passeio',
  'Corredor',
  'Projeto Especial',
  'Polo Turístico',
  'Rotatória',
  'Mini-Rotatória',
  'Circulação',
  'RIST',
  'Pesquisa',
  'Recurso',
  'Contagem de Tráfego ',
  'Análise de Conflitos',
  'Vistoria',
  'Outros',
];

export const EspecificacaoOp: { key: string; labels: string[] }[] = [
  {
    key: 'Infraestrutura Cicloviária',
    labels: [
      'Ciclovia',
      'Ciclofaixa Unidirecional',
      'Ciclofaixa Unidirecional com Segregador',
      'Ciclofaixa Bidirecional',
      'Ciclofaixa Bidirecional com Segregador',
      'Ciclorrota',
    ],
  },
  {
    key: 'Infraestrutura para Pedestre',
    labels: [
      'Travessia Elevada',
      'Faixa Diagonal',
      'Ilha de Refúgio',
      'Calçada Verde',
      'Extensão do Meio-fio',
      'Interseção Elevada',
      'Faixa de Pedestre',
    ],
  },
  {
    key: 'Infraestrutura para Ônibus',
    labels: [
      'Faixa Exclusiva de Ônibus',
      'Sinalização de Parada de Ônibus',
      'BRT',
      'BRS',
    ],
  },
  {
    key: 'Semáforo',
    labels: [
      'Convencional',
      'Centralizado',
      'Pedestre',
      'Ciclista',
      'Semáforo',
    ],
  },
  {
    key: 'Interdição na Pista',
    labels: ['Recape', 'Desvio e Obra', 'Tapa-Buraco'],
  },
  {
    key: 'Renovação de Sinalização',
    labels: [
      'Horizontal',
      'Vertical',
      'Horizontal e Vertical',
      'Projeto Escola',
      'Zona Azul',
      'Esquina Segura Convencional',
      'Esquina Segura 2.0',
      'Videomonitoramento',
      'Sinalização Turística',
      'X de Garagem',
      'Márcação de Área de Conflito',
      'Ponto de Táxi/Mototáxi',
      'Regulamentação de Estacionamento',
      'Vaga Especial',
      'Marcação de Carga/Descarga',
    ],
  },
];

export const DeferidoList = ['Sim', 'Não'];
